import { GET_VENDORS, ADD_VENDOR, UPDATE_VENDOR, UPDATE_VENDOR_PAYABLE } from 'redux/actionTypes';

function findVendorIndex(state, vendorId) {
    return state.findIndex(vendor => vendor.id === vendorId);
};

export default function vendors(state = [], action) {
    switch(action.type) {
        case GET_VENDORS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_VENDOR:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_VENDOR:
            const updateIndex = findVendorIndex(state, action.payload.id);
            return [
                ...state.slice(0, updateIndex),
                action.payload,
                ...state.slice(updateIndex + 1)
            ];
        case UPDATE_VENDOR_PAYABLE:
            const payableIndex = findVendorIndex(state, action.payload.id);
            return [
                ...state.slice(0, payableIndex),
                {
                    ...state[payableIndex],
                    payableAmount: action.payload.payableAmount
                },
                ...state.slice(payableIndex + 1)
            ];
        default:
            return state;
    }
};